import { lazy } from 'react';

export const Recharge = lazy(() => import('./recharge/Recharge'));
export const PurchaseHistoryList = lazy(() => import('./purchase_history/PurchaseHistoryList'));
export const PaymentRedirect = lazy(() => import('./payment/PaymentRedirect'));
export const PaymentStatus = lazy(() => import('./payment/PaymentStatus'));
